export enum Vertical {
  RESTAURANT = 'RESTAURANT',
  EVENTS = 'EVENTS',
  ECOM = 'ECOM',
}

export enum BusinessRegion {
  INDIA = 'India',
  US = 'United States',
}
